module.exports = __webpack_public_path__ + "static/media/lincoln-street-selected.1ef83b6c.svg";